import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';

import { AppComponent } from './app.component';

import { NavMenuComponent } from './navmenu/navmenu.component';
import { DashboardComponent } from './Dashboard/Dashboard.component';
import { BasicPreference } from './BasicPreference/BasicPreference.component';
import { Preferences } from './Preferences/Preferences.component';
import { AddPlanBasic } from './AddPlanBasic/AddPlanBasic.component';

import { LoginComponent } from './login/login.component';
import { HazardPreference } from './HazardPreference/HazardPreference.component';
import { ManageMasterDocumentAddComponent } from './Admin/manage-system-documents/manage-master-document-add.component';

// Layout
import { SiteAdminLayoutComponent } from './_layout/site-admin-layout/site-admin-layout.component';
import { SiteLayoutComponent } from './_layout/site-layout/site-layout.component';

// Admin Component
import { AdminLoginComponent } from './admin/admin-login/admin-login.component';
import { ManageIndustryListComponent } from './admin/manage-industry/manage-industry-list.component';
import { AdminDashboardComponent } from './Admin/admin-dashboard/admin-dashboard.component';
import { ManageIndustryComponent } from './Admin/manage-industry/manage-industry.component';
import { ManageHazardsComponent } from './Admin/manage-hazards/manage-hazards.component';
import { ManageTopicComponent } from './Admin/manage-topic/manage-topic.component';
import { ManageSystemDocumentsComponent } from './Admin/manage-system-documents/manage-system-documents.component';
import { ManageHazardsListComponent } from './Admin/manage-hazards/manage-hazards-list.component';
import { ManageTopicListComponent } from './Admin/manage-topic/manage-topic-list.component';

// Front Services
import { AuthService } from '../Services/AuthService';
import { HazardServices } from '../Services/HazardServices';
import { InductryMasterServices } from '../Services/InductryMaster';
import { UserHazardService } from '../Services/UserHazardService';
import { TokenServices } from '../Services/TokenServices';
import { PreferenceService } from '../Services/preferenceservice.service';
import { UtilityServices, CheckAuth } from '../Services/UtilityService';
import { CompanyServices } from '../Services/CompanyServices';
import { UserLocationServices } from '../Services/UserLocationServices';
import { UserPlanFormatingService } from '../Services/UserPlanFormatingService';
import { DashbordService } from '../Services/DashbordServices';

// Admin Services
import { UserService } from '../Services/Admin/UserServices';
import { AdminInductryMasterServices } from '../Services/Admin/InductryMaster';
import { AdminHazardMasterServices } from '../Services/Admin/HazardServices';
import { AdmindocumentMasterServices } from '../Services/Admin/DocumentMaster';
import { AdminTopicMasterServices } from '../Services/Admin/TopicMaster';


// 3d Party Service / Module / Component
import { ToastrModule } from 'ngx-toastr';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { BlockUIModule } from 'primeng/blockui';
import { ProgressBarModule } from 'primeng/progressbar';
import { GrowlModule } from 'primeng/growl';
import { Ng2GoogleChartsModule } from 'ng2-google-charts';
import { PaginationModule } from 'ngx-bootstrap/pagination';
import { AngularMultiSelectModule } from 'angular2-multiselect-dropdown/angular2-multiselect-dropdown';

//import { CRYPT_CONFIG_PROVIDER, CryptConfigProvider, EncryptionService, EncryptionServiceModule } from 'angular-encryption-service';

//const AppCryptConfigProvider: CryptConfigProvider = {
//  getSalt(): Promise<string> {
//    // TODO: implement providing a salt, which should be unique per user and
//    // base64-encoded.
//    return Promise.resolve('saltsalt');
//  }
//};

@NgModule({
  declarations: [
    AppComponent,
    NavMenuComponent,
    DashboardComponent,
    BasicPreference,
    Preferences,
    LoginComponent,
    HazardPreference,
    AddPlanBasic,
    AdminLoginComponent,
    SiteAdminLayoutComponent,
    SiteLayoutComponent,
    AdminDashboardComponent,
    ManageIndustryComponent,
    ManageHazardsComponent,
    ManageTopicComponent,
    ManageSystemDocumentsComponent,
    ManageIndustryListComponent,
    ManageHazardsListComponent,
    ManageMasterDocumentAddComponent,
    ManageTopicListComponent    
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    ProgressSpinnerModule,
    BlockUIModule,
    ProgressBarModule,
    GrowlModule,
    Ng2GoogleChartsModule,
    PaginationModule.forRoot(),
    ToastrModule.forRoot({
      timeOut: 5000,
      positionClass: 'toast-bottom-right',
      preventDuplicates: true,
      closeButton: true, 
      progressBar: true, 
    }),
    AngularMultiSelectModule,
    //EncryptionServiceModule.forRoot(),
    //ChartModule,
    RouterModule.forRoot([
      { path: '', redirectTo: 'login', pathMatch: 'full' },
      { path: 'login', component: LoginComponent },
      { path: 'admin', component: AdminLoginComponent },
      { path: 'admin/login', component: AdminLoginComponent },      
      {
        path: 'admin',
        component: SiteAdminLayoutComponent,
        children: [
          //{ path: '', component: AdminLoginComponent },
          { path: 'admin-dashboard', component: AdminDashboardComponent },
          { path: 'hazards/add', component: ManageHazardsComponent },
          { path: 'hazards/edit/:id', component: ManageHazardsComponent },
          { path: 'industry', component: ManageIndustryListComponent },
          { path: 'industry/add', component: ManageIndustryComponent },
          { path: 'industry/edit/:id', component: ManageIndustryComponent },
          { path: 'topic', component: ManageTopicListComponent },
          { path: 'topic/add', component: ManageTopicComponent },
          { path: 'topic/edit/:id', component: ManageTopicComponent },
          { path: 'manage-system-documents', component: ManageSystemDocumentsComponent },
          
          { path: 'hazards', component: ManageHazardsListComponent },
          { path: 'system-documents/add', component: ManageMasterDocumentAddComponent }
        ]
      },
      {
        path: '',
        component: SiteLayoutComponent,
        children: [
          //{ path: '', redirectTo: 'login', pathMatch: 'full' },
          { path: 'Dashboard', component: DashboardComponent },
          { path: 'Basic-Preference', component: BasicPreference },
          { path: 'Preferences', component: Preferences },
          { path: 'Hazard-Preference', component: HazardPreference },
          { path: 'login', component: LoginComponent },
          { path: 'Plan-Basic', component: AddPlanBasic },
          //{ path: '**', redirectTo: 'login' }
        ]
      },
      { path: '**', redirectTo: 'login' }
    ])
  ],
  providers: [
    LoginComponent,
    AdminLoginComponent,
    PreferenceService,
    AuthService,
    UtilityServices,
    HazardServices,
    InductryMasterServices,
    UserHazardService,
    TokenServices,
    CheckAuth,
    CompanyServices,
    UserLocationServices,
    UserPlanFormatingService,
    DashbordService,
    UserService,
    AdminInductryMasterServices,
    AdminHazardMasterServices,
    AdmindocumentMasterServices,
    AdminTopicMasterServices,
    { provide: 'BASE_URL', useFactory: getBaseUrl },
    { provide: LocationStrategy, useClass: HashLocationStrategy },
    //{ provide: CRYPT_CONFIG_PROVIDER, useValue: AppCryptConfigProvider }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }

export function getBaseUrl() {
  return document.getElementsByTagName('base')[0].href;
}
